/** The header `header.key` slot (UX-SPEC §17): key status, opens the key dialog. */
import { KEY } from '../strings-bench.ts';
import { openKeyDialog } from './controller.ts';
import { apiKey } from './state.ts';

export function KeyStatus() {
	return (
		<button
			type="button"
			class="btn btn-secondary bench-desktop-only"
			data-testid="bench-key-status"
			onClick={openKeyDialog}
		>
			{apiKey.value ? KEY.hasKey : KEY.noKey}
		</button>
	);
}
